import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InsideBdnViewComponent } from './inside-bdn-view.component';

const routes: Routes = [
  {
    path: '',
    component: InsideBdnViewComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InsideBdnViewRoutingModule {}
